import { Heading, IconComponent, IconList } from '@farol-ds/react'
import classNames from 'classnames'

import styles from './custom-benefits-list.module.scss'

export type CustomBenefitsListProps = {
  benefitsListClassName?: string
  benefitsListIconClassName?: string
  highlightFirstBenefit?: boolean
  customBenefits: { iconType: IconComponent; name: string }[]
}

export function CustomBenefitsList({
  benefitsListClassName,
  benefitsListIconClassName,
  highlightFirstBenefit,
  customBenefits,
}: CustomBenefitsListProps) {
  const benefitsList = customBenefits
  const benefitsListClasses = classNames(styles['benefits-list'], benefitsListClassName)

  const benefitsListIconClasses = classNames(
    styles['custom-benefits-list-icon'],
    benefitsListIconClassName
  )

  return (
    <IconList size="md" unstyled className={benefitsListClasses}>
      {benefitsList.map(({ iconType, name }, index) => {
        const Icon = iconType

        const isFirstBenefit = index === 0
        const isHighlighted = highlightFirstBenefit && isFirstBenefit

        return (
          <IconList.Item
            key={index}
            icon={
              !isHighlighted && (Icon as IconComponent) ? (
                <Icon className={benefitsListIconClasses} />
              ) : null
            }
          >
            {isHighlighted ? (
              <Heading size="sm" asChild>
                <h4 dangerouslySetInnerHTML={{ __html: name }} />
              </Heading>
            ) : (
              <span dangerouslySetInnerHTML={{ __html: name }} />
            )}
          </IconList.Item>
        )
      })}
    </IconList>
  )
}
